import angular from "angular";
/**
 *
 * @param {angular.resource.IResourceService} $resource
 * @param {string} URL
 * @param {string} PATH
 * @param {string} URLAPIPEDIDO
 * @param {string} URLAPIOCORRENCIA
 * @param {string} URLAPIDIVERGENCIA
 * @param {string} URLAPICONFERENCIA
 * @param {string} URL_FATURA_API
 * @param {string} URLAPILOGIN
 * @param {string} URLAPICOLETA
 */
export function PedidoResource(
  $resource,
  URL,
  PATH,
  URLAPIPEDIDO,
  URLAPIPEDIDO_REPLICA,
  URLAPIOCORRENCIA,
  URLAPIDIVERGENCIA,
  URLAPICONFERENCIA,
  URL_FATURA_API,
  URLAPILOGIN,
  URLAPICOLETA,
  URLAPICLIENTE_ETIQUETA
) {
  return $resource(
    URL + PATH + "/orders/:orderId",
    {
      orderId: "@_orderId",
    },
    {
      resumo: {
        method: "GET",
        url: URLAPIPEDIDO + "/orders/:orderId/detail",
      },
      ultimaIncompleta: {
        method: "GET",
        url: URLAPIPEDIDO + "/v1/pedidos/ultimoAberto",
      },
      paraColeta: {
        method: "GET",
        url: URLAPIPEDIDO + "/v1/pedidos/paraColeta",
      },
      ordemServicoAcompanhamento: {
        method: "GET",
        url: URL + PATH + "/orders/latestTrackable",
      },
      listaOs: {
        method: "GET",
        url:
          URLAPIPEDIDO +
          "/v1/pedidos/historico?offset=:offset&limit=:limit:search",
        params: {
          offset: "@offset",
          limit: "@limit",
          search: "@search",
        },
      },
      listaItens: {
        method: "GET",
        url:
          URLAPIPEDIDO_REPLICA +
          "/v1/encomendas/historico?offset=:offset&limit=:limit:search",
        params: {
          offset: "@offset",
          limit: "@limit",
          search: "@search",
        },
      },
      getCustomFilter: {
        method: "GET",
        url: URLAPIDIVERGENCIA + "/v2/contadores/",
      },
      getNaoEncontradas: {
        method: "GET",
        url:
          URLAPIDIVERGENCIA +
          "/nao-encontradas?clienteId=:id&limit=:limit&offset=:offset&situacao=naoEncontradas",
        params: {
          offset: "@offset",
          limit: "@limit",
          id: "@id",
        },
      },
      getContadorNaoEncontradas: {
        method: "GET",
        url: URLAPIDIVERGENCIA + "/nao-encontradas/contadores?clienteId=:id",
        params: {
          id: "@id",
        },
      },
      getContadorAtrasadas: {
        method: "GET",
        url: URLAPIDIVERGENCIA + "/atrasadas/contador/",
      },
      getAtrasadas: {
        method: "GET",
        url: URLAPIDIVERGENCIA + "/atrasadas/",
        params: {
          offset: "@offset",
          limit: "@limit",
          cep: "@cep",
          codigoRastreamento: "@codigoRastreamento",
          documentoDestinatario: '@documentoDestinatario',
          referencia: '@referencia',
          nomeDestinatario: '@nomeDestinatario',
        },
      },
      getPackages: {
        method: "GET",
        url: URLAPIDIVERGENCIA + "/v2/encomendas/",
        params: {
          offset: "@offset",
          limit: "@limit",
          search: "@search",
          dataEntregaPrevistaInicio: "@dataEntregaPrevistaInicio",
          dataEntregaPrevistaFim: "@dataEntregaPrevistaFim",
          noPrazo: "@noPrazo",
          atrasada: "@atrasada",
        },
      },
      getPedidoPorId: {
        method: "GET",
        url: URLAPIPEDIDO + "/v1/pedidos/:id",
        params: {
          id: "@id",
        },
      },
      getEventsPackage: {
        method: "GET",
        url: URLAPIOCORRENCIA + "/encomendas/:id/ocorrencias",
        params: {
          id: "@id",
        },
      },
      packageTracking: {
        method: "GET",
        url: URLAPIOCORRENCIA + "/encomendas/:id/rastreamentos/ultimo",
        params: {
          id: "@id",
        },
      },
      listaFaturas: {
        method: "GET",
        url:
          URL + PATH + "/invoices/historico?offset=:offset&limit=:limit:search",
        params: {
          offset: "@offset",
          limit: "@limit",
          search: "@search",
        },
      },
      detalheFatura: {
        method: "GET",
        url:
          URL_FATURA_API + "/consultas/v1/faturas/detalhe?idFatura=:idFatura",
        params: {
          idFatura: "@idFatura",
        },
      },
      atualizarObservacao: {
        method: "PATCH",
        url: URLAPIPEDIDO + "/v1/pedidos/:pedidoId",
      },
      removerObservacao: {
        method: "DELETE",
        url: URLAPIPEDIDO + "/v1/pedidos/:pedidoId/observacao",
      },
      segundaViaFatura: {
        method: "PUT",
        url: URL + PATH + "/duplicateInvoice",
        params: {
          id: "@id",
        },
      },
      statusOs: {
        method: "GET",
        url: URLAPIPEDIDO + "/orders/:orderId/status",
      },
      statusOsV2: {
        method: "GET",
        url: URLAPIPEDIDO + "/v1/pedidos/:orderId/status",
      },
      coordenada: {
        method: "GET",
        url: URLAPICOLETA + "/v1/orders/:orderId/coordinates",
      },
      obterOpcoes: {
        method: "GET",
        url: URLAPIPEDIDO + "/v2/opcoes/?cep=:cep",
        params: {
          cep: "@cep",
        },
      },
      obterOpcoesComPreco: {
        method: "GET",
        url:
          URLAPIPEDIDO +
          "/v2/opcoes/?cep=:cep&largura=:largura&altura=:altura&comprimento=:comprimento&peso=:peso",
        params: {
          cep: "@cep",
          peso: "@peso",
          altura: "@altura",
          largura: "@largura",
          comprimento: "@comprimento",
        },
      },
      obterDadosCheckout: {
        method: "GET",
        url: URLAPIPEDIDO + "/v1/pedidos/:orderId/checkout",
      },
      atualizarEndereco: {
        method: "PUT",
        url: URLAPIPEDIDO + "/v1/pedidos/:orderId/enderecos",
        params: {
          orderId: "@orderId",
        },
      },
      dismiss: {
        method: "POST",
        url: URLAPIOCORRENCIA + "/encomendas/:id/aceite",
        params: {
          id: "@id",
        },
      },
      visibleToggle: {
        method: "POST",
        url: URLAPIDIVERGENCIA + "/v2/rastreamento-remessa/:id/aceite-toggle",
        params: {
          id: "@id",
        },
      },
      updateNFE: {
        method: "POST",
        url: URLAPIPEDIDO + "/v1/divergencias/:id/nfe/:nfe/correcao",
        params: {
          id: "@id",
          nfe: "@nfe",
        },
      },
      updateEndereco: {
        method: "PATCH",
        url: URLAPIPEDIDO + "/v1/divergencias/:id/endereco",
        params: {
          id: "@id",
        },
      },
      updateSituation: {
        method: "POST",
        url: URLAPICONFERENCIA + "/v2/divergencias/:id/responder",
        params: {
          id: "@id",
        },
      },
      undoDismiss: {
        method: "DELETE",
        url: URLAPIOCORRENCIA + "/encomendas/:id/aceite",
        params: {
          id: "@id",
        },
      },
      printLabel: {
        method: "POST",
        url: URLAPICLIENTE_ETIQUETA + "/freedom/etiquetas/download",
        headers: {
          accept: "application/json, text/plain, */*",
        },
        responseType: "arraybuffer",
        cache: false,
        transformResponse: function (data) {
          var pdf;
          if (data) {
            pdf = new Blob([data], {
              type: "application/pdf",
            });
          }
          return {
            response: pdf,
          };
        },
      },
      printRomaneio: {
        method: "POST",
        url: URLAPICONFERENCIA + "/romaneio-coleta/planejado",
        headers: {
          Accept: "application/pdf",
        },
        responseType: "arraybuffer",
        cache: false,
        transformResponse: function (data) {
          var pdf;
          if (data) {
            pdf = new Blob([data], {
              type: "application/pdf",
            });
          }
          return {
            response: pdf,
          };
        },
      },
      // Check IF OS have pickup receipt
      checkPickupReceipt: {
        method: "GET",
        url: URLAPICOLETA + "/v3/pedido/:id/possui-comprovante-coleta",
        params: {
          id: "@id",
        },
      },

      // Check IF User needs secutiry pick up
      userHasSecuriryPickUp: {
        method: "GET",
        url: URLAPICOLETA + "/v3/cliente/:id/precisa-liberacao-coleta",
        params: {
          id: "@id",
        },
      },

      /**
       * Envia o pedido de liberação de coleta
       * @string {qrCode}
       */
      releasePickUp: {
        method: "POST",
        url: URLAPILOGIN + "/collaborator/authorize",
      },

      printLabelEmLote: {
        method: "GET",
        url: URLAPICLIENTE_ETIQUETA + "/freedom/gerarEtiquetasPendentes/cliente/:id/",
        params: {
          id: "@id",
        },
        headers: {
          accept: "application/pdf",
        },
        responseType: "arraybuffer",
        cache: false,
        transformResponse: function (data) {
          var pdf;
          if (data) {
            pdf = new Blob([data], {
              type: "application/pdf",
            });
          }
          return {
            response: pdf,
          };
        },
      },

      // Check IF OS have pickup receipt
      checkPickupReceipt: {
        method: "GET",
        url: URLAPICOLETA + "/v3/pedido/:id/possui-comprovante-coleta",
        params: {
          id: "@id",
        },
      },

      // Check IF User needs secutiry pick up
      userHasSecuriryPickUp: {
        method: "GET",
        url: URLAPICOLETA + "/v3/cliente/:id/precisa-liberacao-coleta",
        params: {
          id: "@id",
        },
      },

      /**
       * Envia o pedido de liberação de coleta
       * @string {qrCode}
       */
      releasePickUp: {
        method: "POST",
        url: URLAPILOGIN + "/collaborator/authorize",
      },

      /**
       * Busca os dados do motorista
       * @integer {id}
       */
      pickUpWarn: {
        method: "POST",
        url: URLAPILOGIN + "/pickup-warn",
      },
      getPackage: {
        method: "GET",
        url: URLAPIPEDIDO + "/v1/pedidos/:orderId/encomendas/:packageId",
        params: {
          orderId: "@orderId",
          packageId: "@packageId",
        },
      },
      saveReverse: {
        method: "POST",
        url: URLAPIPEDIDO + "/v1/reversas/",
      },
      getReverseDeliveryTypes: {
        method: "GET",
        url: URLAPIPEDIDO + "/v1/reversas/tipos-entrega",
        params: {
          nomeRemetente: "@nomeRemetente",
          cepRemetente: "@cepRemetente",
          logradouroRemetente: "@logradouroRemetente",
          numeroRemetente: "@numeroRemetente",
          bairroRemetente: "@bairroRemetente",
          cidadeRemetente: "@cidadeRemetente",
          ufRemetente: "@ufRemetente",
          cepDestinatario: "@cepDestinatario",
        },
        isArray: true,
      },
      getReverses: {
        method: "GET",
        url: URLAPIPEDIDO + "/v1/reversas",
        params: {
          offset: "@offset",
          limit: "@limit",
          cepRemetente: "@cepRemetente",
          nomeRemetente: "@nomeRemetente",
          rastreamento: "@rastreamento",
          pedido: "@pedido",
          codigoTransportadora: "@codigoTransportadora",
          situacao: "@situacao",
        },
      },
      getReverseOrigin: {
        method: "GET",
        url: URLAPIPEDIDO + "/v1/reversas/:id/origem",
        params: {
          id: "@id",
        },
      },
      deleteReverse: {
        method: "DELETE",
        url: URLAPIPEDIDO + "/v1/reversas/:id",
        params: {
          id: "@id",
        },
      },
      sendReverseAuthorization: {
        method: "POST",
        url: URLAPIPEDIDO + "/v1/reversas/:id/enviar-autorizacao",
        params: {
          id: "@id",
        },
      },
      getChegouMandae: {
        method: "GET",
        url: URLAPIPEDIDO + "/v1/unidades/:unidadeId/pedidos/chegou-mandae",
        params: {
          unidadeId: "@unidadeId",
        },
      },
      cadastroManual: {
        method: "POST",
        url: URLAPIPEDIDO + "/v1/pedidos/:pedidoId/manual",
        params: {
          pedidoId: "@pedidoId",
        },
      },
      datasProximasUteis: {
        method: "GET",
        isArray: true,
        url: URLAPIPEDIDO + "/datas/proximas-uteis",
      },
      getDivergenciaMaisRecente: {
        method: "GET",
        url: URLAPICONFERENCIA + "/v2/divergencias/:id",
        params: {
          id: "@id",
        },
      },
    }
  );
}
